import { render, staticRenderFns } from "./cards-board.vue?vue&type=template&id=48f4f347&scoped=true"
import script from "./cards-board.vue?vue&type=script&lang=js"
export * from "./cards-board.vue?vue&type=script&lang=js"
import style0 from "./cards-board.vue?vue&type=style&index=0&id=48f4f347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4f347",
  null
  
)

export default component.exports